module.exports = "/_next/static/images/bn-e1882e0d1a24b1cf738cae33f46ed517.svg";